import { graphql } from '~/lib/graphql'

export const ReserveInfoViewer = graphql(`
  fragment ReserveInfoViewer on Viewer {
    name
    phoneNumberCertified
    loginSite
  }
`)
